import * as PIXI from 'pixi.js';
import GSOParasite from '../../../Game/Base/GSOParasite';
import Global from '../../../Game/Global';
import Vector from '../../../Game/Base/Math/Vector';
import Angle from '../../../Game/Base/Math/Angle';
import { Shape } from '../../../Game/Level/Blok';
import MoveToCanvasButton from '../../MoveToCanvasButton';
import { MovementBehaviour, ResizeBehaviour, RotationBehaviour, RotationDirection } from '../../shared';
import LineVisuals from './LineVisuals';
import AssetManager from '../../../Game/Base/AssetManager';

export default class SelectedStateOverlay extends GSOParasite {
    constructor(realParent, stepParent) {
        super(realParent, stepParent);

        this.pixiContainer = null;
        this.pixiGraphics = null;

        this.moveToButton = new MoveToCanvasButton(this, null);
        this.moveToButton.onMouseDown = function(mousePositionP) {
            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            const state = realParent.getSelectedBlokSelectedState();
            this.dragOffset = new Vector(0, 0);
            this.dragOffset.x = state.movementGoal.x - mousePosition.x;
            this.dragOffset.y = state.movementGoal.y - mousePosition.y;
        };
        this.moveToButton.onMouseMove = function(mousePositionP) {
            const game = this.getGame();
            const state = realParent.getSelectedBlokSelectedState();
            const mousePosition = game.canvasToGamePosition(mousePositionP);
            state.movementGoal.x = Math.round(mousePosition.x + this.dragOffset.x);
            state.movementGoal.y = Math.round(mousePosition.y + this.dragOffset.y);

            if (game.keys.Shift || game.keys.ShiftLeft || game.keys.ShiftRight) {
                state.movementGoal.x = Math.round(state.movementGoal.x / (Global.NATIVE_BLOCK_SIZE / 2)) * (Global.NATIVE_BLOCK_SIZE / 2);
                state.movementGoal.y = Math.round(state.movementGoal.y / (Global.NATIVE_BLOCK_SIZE / 2)) * (Global.NATIVE_BLOCK_SIZE / 2);
            } else if (game.keys.Control || game.keys.ControlLeft || game.keys.ControlRight) {
                state.movementGoal.x = Math.round(state.movementGoal.x / (Global.NATIVE_BLOCK_SIZE / 8)) * (Global.NATIVE_BLOCK_SIZE / 8);
                state.movementGoal.y = Math.round(state.movementGoal.y / (Global.NATIVE_BLOCK_SIZE / 8)) * (Global.NATIVE_BLOCK_SIZE / 8);
            }
        };
        this.moveToButton.disable();

        this.moveToLine = new LineVisuals(this, AssetManager.get('img.move_to'));
        this.moveToLine.disable();
    }

    onCreateVisuals() {
        this.pixiContainer = new PIXI.Container();
        this.getParentPixiContainer().addChild(this.pixiContainer);

        this.pixiGraphics = new PIXI.Graphics();
        this.pixiContainer.addChild(this.pixiGraphics);
    }

    onUpdateVisuals() {
        const blok = this.getAttachedStepParent();
        this.pixiContainer.rotation = -blok.rotation;
        this.updateButtonPositions();

        const state = this._realParent.getSelectedBlokSelectedState();
        if (this.moveToButton._enabled && state.movementBehaviour !== MovementBehaviour.backAndForth && state.movementBehaviour !== MovementBehaviour.to) {
            this.moveToButton.disable();
            this.moveToLine.disable();
        }
        if (!this.moveToButton._enabled && (state.movementBehaviour === MovementBehaviour.backAndForth || state.movementBehaviour === MovementBehaviour.to)) {
            this.moveToButton.enable();
            this.moveToButton._gsoCreateVisuals();
            this.moveToLine.enable();
            this.moveToLine._gsoCreateVisuals();
        }
        this.moveToLine.to = state.movementGoal.copy();

        this.pixiGraphics.clear();

        if (state.resizeBehaviour !== ResizeBehaviour.none || (state.rotationBehaviour === RotationBehaviour.once || state.rotationBehaviour === RotationBehaviour.backAndForth)) {
            this.pixiGraphics.lineStyle(1.5, 0xb4ea04);
            let width = 1;
            let height = 1;
            if (state.resizeBehaviour !== ResizeBehaviour.none) {
                width = state.resizeWidth;
                height = state.resizeHeight;
            }
            if (blok.shape === Shape.rectangle) {
                this.pixiGraphics.drawRect(
                    ((-blok.size.x * Global.NATIVE_BLOCK_SIZE) / 2) * width,
                    ((-blok.size.y * Global.NATIVE_BLOCK_SIZE) / 2) * height,
                    blok.size.x * Global.NATIVE_BLOCK_SIZE * width,
                    blok.size.y * Global.NATIVE_BLOCK_SIZE * height
                );
            } else {
                this.pixiGraphics.drawCircle(0, 0, ((blok.size.x * Global.NATIVE_BLOCK_SIZE) / 2) * width);
            }
            this.pixiGraphics.rotation = blok.rotation;
            if (state.rotationBehaviour === RotationBehaviour.once || state.rotationBehaviour === RotationBehaviour.backAndForth) {
                this.pixiGraphics.rotation += state.rotationAngle;
                if (state.rotationDirection === RotationDirection.left) this.pixiGraphics.rotation *= -1;
            }
        }
        this.moveToLine.speed = state.speed;
    }

    onDestroyVisuals() {
        this.pixiContainer.destroy();
        this.pixiGraphics.destroy();
    }

    updateButtonPositions() {
        const blok = this.getAttachedStepParent();
        const state = this._realParent.getSelectedBlokSelectedState();
        this.moveToButton.position.x = state.movementGoal.x;
        this.moveToButton.position.y = state.movementGoal.y;
        this.moveToButton.rotation = blok.rotation;
    }

    onAttach() {
        const blok = this.getAttachedStepParent();
        const state = this._realParent.getSelectedBlokSelectedState();
        this.moveToButton.blok = blok;
        this.updateButtonPositions();
    }

    onDetach() {
        this.moveToButton.enable();
        this.moveToLine.enable();
    }

    getMouseEventWorldPosition(evt) {
        const rect = this._realParent.canvas.getBoundingClientRect();
        return this._realParent.game.canvasToGamePosition(new Vector(evt.clientX - rect.left, evt.clientY - rect.top));
    }

    getMouseEventPosition(evt) {
        const rect = this._realParent.canvas.getBoundingClientRect();
        return new Vector(evt.clientX - rect.left, evt.clientY - rect.top);
    }
}
